/** Sync with src/index.css design tokens */
export const BRAND = {
  accent: "#9fe870",
  accentHover: "#8cd65d",
  accentMuted: "rgba(159, 232, 112, 0.25)",
  accentLink: "#163300",
  accentSubtle: "#e9f9de",
  foreground: "#163300",
  muted: "#4e6553",
  mutedLight: "#7b8e7f",
  border: "#e0e4e6",
  canvas: "#f2f5f7",
  canvasHover: "#e5e9eb",
  fuelLow: "#9fe870",
  fuelHigh: "#e67e22",
} as const;

export const CHART_COLORS = [
  BRAND.accent,
  "#b8f094",
  BRAND.foreground,
  BRAND.muted,
  BRAND.mutedLight,
  BRAND.border,
] as const;
